import {Component, Pipe, PipeTransform} from '@angular/core';
import { EbayitemService } from '../services/ebayitem.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GLOBAL } from '../services/global';
@Pipe ({
   name : 'Longago',
})

export class Longago implements PipeTransform {

	public respuesta;
	public url;

	constructor(
		
		){
			this.url = GLOBAL.url;
	}



   transform(date1: string) {

    var date=  new Date(date1);
    let seconds = Math.floor((new Date().valueOf() - date.valueOf()) / 1000);

  let interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval) + " years";
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) + " months";
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) + " days";
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + " hours";
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + " minutes";
  }
  return Math.floor(seconds) + " seconds";
   	 
  
   }


}